// Vendor Libs
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {get} from 'lodash';

// Redux Actions
import {
    registerForm,
    setFieldValue,
    setFieldValues,
    setFormCustomPath,
    setFormSubmitted,
    resetForm,
} from '../actions/form-data-actions';

// Containers
import FormContextProvider from './form-context-provider';

// Configs
import servicesFormConfig from '../../config/services-form-config';

function FormData({
    children,
    formData,
    formName,
    locallyLocked,
    lockedRecords,
    registerForm,
    resetForm,
    routerParams,
    servicesSearchData,
    setFieldValue,
    setFieldValues,
    setFormCustomPath,
    setFormSubmitted,
}) {
    useEffect(() => {
        registerForm(formName);
    }, []);

    const getChildrenProps = () => {
        const providerServiceDataKey = get(servicesFormConfig, [formName, 'providerServiceDataKey']);

        return {
            formData: get(formData, [formName], {}),
            formName,
            locallyLocked,
            lockedRecords,
            registerForm,
            resetForm: (submitted, resetValues, editing) => resetForm(formName, submitted, resetValues, editing),
            routerParams,
            searchFetching: get(servicesSearchData, [providerServiceDataKey, 'fetching']),
            searchValues: get(servicesSearchData, [providerServiceDataKey, 'searchData', 'content', '0'], {}),
            setFieldValue: (fieldName, value) => setFieldValue(formName, fieldName, value),
            setFieldValues: (values) => setFieldValues(formName, values),
            setFormCustomPath: (customPath) => setFormCustomPath(formName, customPath),
            setFormSubmitted: (actionShouldFetch, submitted) =>
                setFormSubmitted(actionShouldFetch, formName, formName, submitted),
        };
    };

    return (
        <FormContextProvider
            {...{
                formName,
                setFieldValue,
            }}
        >
            {children ? children(getChildrenProps()) : null}
        </FormContextProvider>
    );
}

FormData.propTypes = {
    children: PropTypes.func.isRequired,
    formData: PropTypes.object,
    formName: PropTypes.string,
    locallyLocked: PropTypes.object,
    lockedRecords: PropTypes.object,
    registerForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    routerParams: PropTypes.object.isRequired,
    servicesSearchData: PropTypes.object,
    setFieldValue: PropTypes.func.isRequired,
    setFieldValues: PropTypes.func.isRequired,
    setFormCustomPath: PropTypes.func.isRequired,
    setFormSubmitted: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    locallyLocked: get(state.recordLocking, 'locallyLocked', {}),
    lockedRecords: get(state.recordLocking, 'lockedRecords', {}),
    formData: state.formData,
    routerParams: get(state.router, 'routerParams', {}),
    servicesSearchData: state.servicesSearchData,
});

const mapDispatchToProps = {
    registerForm,
    setFieldValue,
    setFieldValues,
    setFormCustomPath,
    setFormSubmitted,
    resetForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(FormData);
